














































  import { Component, Mixins } from "vue-property-decorator";
  import { ContentService } from "@/service/content.service";
  import CommonMixin, { WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START } from "@/mixins/common-mixins";
  import { AppData } from "@/models/app-data";
  import PageLoader from "@/components/PageLoader.vue"
import { MatchHSAndGSRPReferralContent } from "@/models/content/match-hs-and-gsrp-referral";
  
  @Component({
    components: {PageLoader},
  })
  export default class MatchHSAndGSRPReferral extends Mixins(CommonMixin) {
    content: MatchHSAndGSRPReferralContent = {} as MatchHSAndGSRPReferralContent;
    appData = {} as AppData;
    textDirection = 'ltr'
    loadDataFinished = false
  
    async mounted(): Promise<void> {
      try {
        const contentService = new ContentService(this.$route);
        this.content = await contentService.getMatchHSAndGSRPReferralContent();
        this.textDirection = contentService.TextDirection();  
  
        this.appData = this.getAppData();
        if (this.appData != null) {
          this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START
          this.saveAppData(this.appData);
          await this.putWorkflowStep( this.appData.workflowId, "MatchHSAndGSRPReferral") 
          await this.postWorkflowEligible(this.appData?.workflowId, this.appData.preferredProgram);
        }
        this.postNavigatedToParent();
        this.loadDataFinished = true
      } catch (error) {
        this.showError(error as any);
      }
    }

      public async handleLearnMore(): Promise<void> {
    window.open( this.content.LearnMoreUrl, "_blank"); 
    await this.publishWebLearnMoreClickEvent( this.appData.workflowId) 
  }
  }
  